export const bloodGroups = {
  ABG: {
    label: 'Blood Gas (arterial)',
    elements: [
      { name: 'pH', units: '-', refLow: 7.35, refHigh: 7.45 },
      { name: 'pCO2', units: 'kPa', refLow: 4.6, refHigh: 6.0 },
      { name: 'pO2', units: 'kPa', refLow: 11, refHigh: 13 },
      { name: 'HCO3', units: 'mmol/L', refLow: 22, refHigh: 28 },
      { name: 'Base', units: 'mmol/L', refLow: -3, refHigh: 3 },
      { name: 'K+', units: 'mmol/L', refLow: 3.5, refHigh: 4.5 },
      { name: 'Na+', units: 'mmol/L', refLow: 136, refHigh: 146 },
      { name: 'Ca2+', units: 'mmol/L', refLow: 1.15, refHigh: 1.3 },
      { name: 'Cl-', units: 'mmol/L', refLow: 101, refHigh: 110 },
      { name: 'Glu', units: 'mmol/L', refLow: 3.5, refHigh: 5.4 },
      { name: 'Lac', units: 'mmol/L', refLow: 0, refHigh: 2 },
      { name: 'Hb', units: 'g/L', refLow: 120, refHigh: 150 },
      { name: 'sO2', units: '%', refLow: 95, refHigh: 99 },
    ],
    presets: {
    Normal: {
        pH: 7.37,
        pCO2: 5.0,
        pO2: 10.6,
        HCO3: 25,
        Base: 0.2,
        'K+': 4.2,
        'Na+': 138,
        'Ca2+': 1.17,
        'Cl-': 104,
        Glu: 4.2,
        Lac: 0.3,
        Hb: 136,
        sO2: 99,
    },
    'Resp acidosis (uncompensated)': {
        pH: 7.25,
        pCO2: 8.0,
        pO2: 10.0,
        HCO3: 24,
        Base: 0,
        'K+': 4.5,
        'Na+': 138,
        'Ca2+': 1.17,
        'Cl-': 103,
        Glu: 4.2,
        Lac: 0.4,
        Hb: 136,
        sO2: 93,
    },
    'Resp acidosis (partially compensated)': {
        pH: 7.32,
        pCO2: 8.0,
        pO2: 9.6,
        HCO3: 30,
        Base: 5,
        'K+': 4.6,
        'Na+': 138,
        'Ca2+': 1.16,
        'Cl-': 101,
        Glu: 4.0,
        Lac: 0.5,
        Hb: 136,
        sO2: 91,
    },
    'Resp alkalosis': {
        pH: 7.49,
        pCO2: 3.7,
        pO2: 13.1,
        HCO3: 23,
        Base: -2,
        'K+': 3.4,
        'Na+': 139,
        'Ca2+': 1.19,
        'Cl-': 103,
        Glu: 4.3,
        Lac: 0.2,
        Hb: 136,
        sO2: 100,
    },
    'Met acidosis (high anion gap)': {
        pH: 7.25,
        pCO2: 4.0,
        pO2: 13.1,
        HCO3: 14,
        Base: -10,
        'K+': 5.0,
        'Na+': 138,
        'Ca2+': 1.16,
        'Cl-': 100,
        Glu: 4.4,
        Lac: 6.2,
        Hb: 136,
        sO2: 98,
    },
    'Met acidosis (low anion gap)': {
        pH: 7.27,
        pCO2: 4.1,
        pO2: 12.8,
        HCO3: 15,
        Base: -8,
        'K+': 4.9,
        'Na+': 137,
        'Ca2+': 1.17,
        'Cl-': 112,
        Glu: 4.1,
        Lac: 1.1,
        Hb: 136,
        sO2: 97,
    },
    'Met alkalosis': {
        pH: 7.53,
        pCO2: 6.4,
        pO2: 12.3,
        HCO3: 35,
        Base: 9,
        'K+': 3.0,
        'Na+': 137,
        'Ca2+': 1.13,
        'Cl-': 95,
        Glu: 4.0,
        Lac: 0.2,
        Hb: 136,
        sO2: 96,
    },
    'Mixed acidosis': {
        pH: 7.10,
        pCO2: 8.0,
        pO2: 11.3,
        HCO3: 14,
        Base: -12,
        'K+': 5.4,
        'Na+': 135,
        'Ca2+': 1.15,
        'Cl-': 104,
        Glu: 5.2,
        Lac: 5.9,
        Hb: 136,
        sO2: 91,
    },
    'Mixed alkalosis': {
        pH: 7.57,
        pCO2: 3.7,
        pO2: 13.3,
        HCO3: 34,
        Base: 8,
        'K+': 3.1,
        'Na+': 139,
        'Ca2+': 1.12,
        'Cl-': 98,
        Glu: 4.3,
        Lac: 0.3,
        Hb: 136,
        sO2: 99,
    },
    'T1RF': {
      pH: 7.46,
      pCO2: 4.2,
      pO2: 7.2,
      HCO3: 23,
      Base: -1,
      'K+': 4.0,
      'Na+': 138,
      'Ca2+': 1.15,
      'Cl-': 102,
      Glu: 5.2,
      Lac: 1.2,
      Hb: 140,
      sO2: 88,
    },
    'T2RF': {
      pH: 7.28,
      pCO2: 8.5,
      pO2: 7.8,
      HCO3: 30,
      Base: 4,
      'K+': 4.5,
      'Na+': 137,
      'Ca2+': 1.10,
      'Cl-': 100,
      Glu: 6.0,
      Lac: 1.5,
      Hb: 145,
      sO2: 90,
    }
  }
  },
  FBC: {
    label: 'Full Blood Count',
    elements: [
      { name: 'Hb', units: 'g/L', refLow: 120, refHigh: 160 },
      { name: 'WCC', units: 'x10^9/L', refLow: 3.6, refHigh: 11 },
      { name: 'Haematocrit', units: 'L/L', refLow: 0.37, refHigh: 0.54 },
      { name: 'MCV', units: 'fL', refLow: 80, refHigh: 100 },
      { name: 'Platelets', units: 'x10^9/L', refLow: 140, refHigh: 400 },
      { name: 'Neutrophils', units: 'x10^9/L', refLow: 1.8, refHigh: 7.5 },
      { name: 'Lymphocytes', units: 'x10^9/L', refLow: 1.0, refHigh: 4.0 },
      { name: 'Monocytes', units: 'x10^9/L', refLow: 0.2, refHigh: 0.8 },
      { name: 'Eosinophils', units: 'x10^9/L', refLow: 0.1, refHigh: 0.4 },
      { name: 'Basophils', units: 'x10^9/L', refLow: 0.02, refHigh: 0.1 },
    ],
    presets: {
  Normal: {
    Hb: 140,
    WCC: 6.2,
    Haematocrit: 0.42,
    MCV: 90,
    Platelets: 250,
    Neutrophils: 4.2,
    Lymphocytes: 2.1,
    Monocytes: 0.4,
    Eosinophils: 0.13,
    Basophils: 0.05
  },

  'Microcytic Anaemia': {
    Hb: 95,
    WCC: 5.5,
    Haematocrit: 0.30,
    MCV: 68,
    Platelets: 420,
    Neutrophils: 3.8,
    Lymphocytes: 1.9,
    Monocytes: 0.4,
    Eosinophils: 0.1,
    Basophils: 0.04
  },

  'Macrocytic Anaemia': {
    Hb: 85,
    WCC: 3.2,
    Haematocrit: 0.26,
    MCV: 110,
    Platelets: 110,
    Neutrophils: 1.5,
    Lymphocytes: 1.2,
    Monocytes: 0.3,
    Eosinophils: 0.05,
    Basophils: 0.02
  },

  'Acute Infection (Neutrophilia)': {
    Hb: 135,
    WCC: 15.8,
    Haematocrit: 0.40,
    MCV: 88,
    Platelets: 320,
    Neutrophils: 13.2,
    Lymphocytes: 1.4,
    Monocytes: 0.8,
    Eosinophils: 0.05,
    Basophils: 0.03
  },

  'Viral Infection (Lymphocytosis)': {
    Hb: 138,
    WCC: 11.5,
    Haematocrit: 0.41,
    MCV: 90,
    Platelets: 230,
    Neutrophils: 3.0,
    Lymphocytes: 7.2,
    Monocytes: 0.9,
    Eosinophils: 0.1,
    Basophils: 0.04
  },

  'Thrombocytopenia': {
    Hb: 142,
    WCC: 6.5,
    Haematocrit: 0.43,
    MCV: 89,
    Platelets: 35,
    Neutrophils: 4.0,
    Lymphocytes: 2.0,
    Monocytes: 0.4,
    Eosinophils: 0.1,
    Basophils: 0.05
  },

  'Aplastic Anaemia': {
    Hb: 70,
    WCC: 1.5,
    Haematocrit: 0.21,
    MCV: 92,
    Platelets: 20,
    Neutrophils: 0.8,
    Lymphocytes: 0.5,
    Monocytes: 0.1,
    Eosinophils: 0.02,
    Basophils: 0.01
  }
},
  },
  UandE: {
    label: 'U&E',
    elements: [
      { name: 'Sodium', units: 'mmol/L', refLow: 135, refHigh: 146 },
      { name: 'Potassium', units: 'mmol/L', refLow: 3.5, refHigh: 5.3 },
      { name: 'Urea', units: 'mmol/L', refLow: 2.5, refHigh: 7.8 },
      { name: 'Creatinine', units: 'μmol/L', refLow: 59, refHigh: 104 },
      { name: 'eGFR', units: '/min/1.73m2', refLow: 60, refHigh: 90 },
    ],
    presets: {
      Normal: {
        Sodium: 138,
        Potassium: 3.9,
        Urea: 4.6,
        Creatinine: 86,
        eGFR: 90
      },

      'Hyperkalaemia (mild)': {
        Sodium: 138,
        Potassium: 5.7,
        Urea: 4.8,
        Creatinine: 90,
        eGFR: 85
      },

      'Hyperkalaemia (moderate)': {
        Sodium: 137,
        Potassium: 6.3,
        Urea: 5.2,
        Creatinine: 95,
        eGFR: 80
      },

      'Hyperkalaemia (severe)': {
        Sodium: 136,
        Potassium: 7.0,
        Urea: 6.0,
        Creatinine: 110,
        eGFR: 65
      },

      'Hypokalaemia': {
        Sodium: 140,
        Potassium: 2.8,
        Urea: 4.2,
        Creatinine: 80,
        eGFR: 95
      },

      'Hyponatraemia (mild)': {
        Sodium: 132,
        Potassium: 4.0,
        Urea: 4.5,
        Creatinine: 85,
        eGFR: 90
      },

      'Hyponatraemia (moderate)': {
        Sodium: 125,
        Potassium: 4.2,
        Urea: 4.0,
        Creatinine: 82,
        eGFR: 90
      },

      'Hyponatraemia (severe)': {
        Sodium: 118,
        Potassium: 4.5,
        Urea: 3.8,
        Creatinine: 80,
        eGFR: 90
      },

      'Hypernatraemia (mild)': {
        Sodium: 148,
        Potassium: 4.1,
        Urea: 5.5,
        Creatinine: 95,
        eGFR: 85
      },

      'Hypernatraemia (severe)': {
        Sodium: 158,
        Potassium: 4.3,
        Urea: 8.5,
        Creatinine: 120,
        eGFR: 60
      },

      'AKI (pre-renal)': {
        Sodium: 140,
        Potassium: 5.2,
        Urea: 18.0,
        Creatinine: 180,
        eGFR: 35
      },

      'AKI (intrinsic)': {
        Sodium: 138,
        Potassium: 5.5,
        Urea: 14.0,
        Creatinine: 220,
        eGFR: 25
      },

      'AKI (post-renal)': {
        Sodium: 139,
        Potassium: 5.8,
        Urea: 16.5,
        Creatinine: 250,
        eGFR: 20
      },

      'CKD 3': {
        Sodium: 138,
        Potassium: 4.8,
        Urea: 10.5,
        Creatinine: 140,
        eGFR: 45
      },

      'CKD 4': {
        Sodium: 137,
        Potassium: 5.2,
        Urea: 18.0,
        Creatinine: 250,
        eGFR: 20
      },

      'CKD 5': {
        Sodium: 135,
        Potassium: 5.8,
        Urea: 28.0,
        Creatinine: 486,
        eGFR: 8
      }
    },
  },
  LFT: {
    label: 'LFT',
    elements: [
      { name: 'Albumin', units: 'g/L', refLow: 35, refHigh: 55 },
      { name: 'Total bilirubin', units: 'μmol/L', refLow: 3, refHigh: 20 },
      { name: 'Conjugated bilirubin', units: 'μmol/L', refLow: 0, refHigh: 14 },
      { name: 'ALT', units: 'IU/L', refLow: 0, refHigh: 45 },
      { name: 'AST', units: 'IU/L', refLow: 0, refHigh: 50 },
      { name: 'ALP', units: 'IU/L', refLow: 90, refHigh: 300 },
      { name: 'GGT', units: 'IU/L', refLow: 0, refHigh: 60 },
      { name: 'Total protein', units: 'g/L', refLow: 60, refHigh: 80 },
    ],
  presets: {
    Normal: {
      Albumin: 54,
      'Total bilirubin': 12,
      'Conjugated bilirubin': 0,
      ALT: 23,
      AST: 33,
      ALP: 140,
      GGT: 12,
      'Total protein': 72
    },

    'Hepatocellular Injury (mild)': {
      Albumin: 50,
      'Total bilirubin': 18,
      'Conjugated bilirubin': 4,
      ALT: 120,
      AST: 100,
      ALP: 150,
      GGT: 35,
      'Total protein': 70
    },

    'Hepatocellular Injury (severe)': {
      Albumin: 42,
      'Total bilirubin': 80,
      'Conjugated bilirubin': 40,
      ALT: 950,
      AST: 820,
      ALP: 180,
      GGT: 90,
      'Total protein': 68
    },

    'Cholestasis': {
      Albumin: 48,
      'Total bilirubin': 36,
      'Conjugated bilirubin': 24,
      ALT: 90,
      AST: 80,
      ALP: 264,
      GGT: 118,
      'Total protein': 72
    },

    'Obstructive Jaundice': {
      Albumin: 46,
      'Total bilirubin': 42,
      'Conjugated bilirubin': 95,
      ALT: 180,
      AST: 160,
      ALP: 520,
      GGT: 300,
      'Total protein': 74
    },

    'Alcohol-related Liver Disease': {
      Albumin: 19,
      'Total bilirubin': 55,
      'Conjugated bilirubin': 35,
      ALT: 65,
      AST: 140,
      ALP: 180,
      GGT: 350,
      'Total protein': 75
    },

    'Cirrhosis (compensated)': {
      Albumin: 27,
      'Total bilirubin': 35,
      'Conjugated bilirubin': 20,
      ALT: 55,
      AST: 70,
      ALP: 160,
      GGT: 120,
      'Total protein': 68
    },

    'Cirrhosis (decompensated)': {
      Albumin: 21,
      'Total bilirubin': 88,
      'Conjugated bilirubin': 64,
      ALT: 60,
      AST: 90,
      ALP: 180,
      GGT: 140,
      'Total protein': 62
    },

},
  },
  CRP: {
    label: 'CRP',
    elements: [
      { name: 'CRP', units: 'mg/L', refLow: 0, refHigh: 5 },
    ],
    presets: {
      Normal: {
        CRP: 1
      },
    },
  },
  Coag: {
  label: 'Coagulation Screen',
  elements: [
    { name: 'INR', units: '-', refLow: 0.8, refHigh: 1.2 },
    { name: 'PT', units: 's', refLow: 9.4, refHigh: 12.5 },
    { name: 'APTT', units: 's', refLow: 25.4, refHigh: 36.9 },
    { name: 'Fibrinogen', units: 'mg/dL', refLow: 200, refHigh: 393 },
  ],
  presets: {
    Normal: {
      INR: 1.0,
      PT: 9.8,
      APTT: 28.3,
      Fibrinogen: 250
    },

    'Raised INR': {
      INR: 2.6,
      PT: 28.0,
      APTT: 35.0,
      Fibrinogen: 260
    },

    'Raised INR (severe)': {
      INR: 5.5,
      PT: 60.0,
      APTT: 45.0,
      Fibrinogen: 250
    },

    'LMWH': {
      INR: 1.1,
      PT: 11.5,
      APTT: 63.0,
      Fibrinogen: 270
    },

    'Liver Disease': {
      INR: 2.2,
      PT: 32.0,
      APTT: 50.0,
      Fibrinogen: 180
    },

    'Vitamin K Deficiency': {
      INR: 2.0,
      PT: 30.0,
      APTT: 40.0,
      Fibrinogen: 260
    },

    'DIC (early)': {
      INR: 1.5,
      PT: 20.0,
      APTT: 45.0,
      Fibrinogen: 180
    },

    'DIC (established)': {
      INR: 2.5,
      PT: 40.0,
      APTT: 70.0,
      Fibrinogen: 90
    },

    'Haemophilia (A/B)': {
      INR: 1.0,
      PT: 10.5,
      APTT: 80.0,
      Fibrinogen: 280
    },
  }
  },
  Ddimer: {
    label: 'D-dimer',
    elements: [
        {name: 'D-dimer', units: 'ng/mL', refLow: 0, refHigh: 500}
    ],
    presets: {
        Normal: {
            'D-dimer': 50
        },
    }
  },
  Lipids: {
    label: 'Lipid Profile',
    elements: [
      { name: 'Total cholesterol', units: 'mmol/L', refLow: 0, refHigh: 5 },
      { name: 'LDL-C', units: 'mmol/L', refLow: 0, refHigh: 3 },
      { name: 'HDL-C', units: 'mmol/L', refLow: 1, refHigh: 5 },
      { name: 'Triglycerides', units: 'mmol/L', refLow: 0, refHigh: 2 },
    ],
    presets: {
      Normal: {
        'Total cholesterol': 2.2,
        'LDL-C': 2,
        'HDL-C': 3,
        Triglycerides: 0.5
      },
    },
  },
  Amylase: {
    label: 'Amylase',
    elements: [
      { name: 'Amylase', units: 'u/L', refLow: 70, refHigh: 300 },
    ],
    presets: {
      Normal: {
        Amylase: 85,
      },
    },
  },
  TFT: {
  label: 'TFT',
  elements: [
    { name: 'TSH', units: 'mu/L', refLow: 0.5, refHigh: 5.5 },
    { name: 'fT4', units: 'pmol/L', refLow: 9, refHigh: 18 },
    { name: 'tT4', units: 'nmol/L', refLow: 70, refHigh: 140 },
    { name: 'fT3', units: 'pmol/L', refLow: 3.1, refHigh: 6.8 },
  ],
  presets: {
    Normal: {
      TSH: 3.2,
      fT4: 12,
      tT4: 110,
      fT3: 4.1
    },

    'Primary Hypothyroidism': {
      TSH: 18.5,
      fT4: 6.5,
      tT4: 55,
      fT3: 2.8
    },

    'Subclinical Hypothyroidism': {
      TSH: 8.2,
      fT4: 12,
      tT4: 105,
      fT3: 4.0
    },

    'Primary Hyperthyroidism': {
      TSH: 0.01,
      fT4: 32,
      tT4: 220,
      fT3: 9.5
    },

    'Thyrotoxicosis': {
      TSH: 0.01,
      fT4: 15,
      tT4: 130,
      fT3: 10.2
    },

    'Subclinical Hyperthyroidism': {
      TSH: 0.08,
      fT4: 14,
      tT4: 115,
      fT3: 4.5
    },

    'Secondary Hypothyroidism': {
      TSH: 0.4,
      fT4: 6.0,
      tT4: 50,
      fT3: 2.5
    },

    'Secondary Hyperthyroidism': {
      TSH: 6.8,
      fT4: 28,
      tT4: 210,
      fT3: 8.0
    },

    'Euthyroid Sick Syndrome': {
      TSH: 0.6,
      fT4: 10,
      tT4: 65,
      fT3: 2.0
    },

    'Overtreated Hypothyroidism': {
      TSH: 0.02,
      fT4: 24,
      tT4: 180,
      fT3: 5.5
    }
  }
  },
  CK: {
    label: 'Creatine Kinase',
    elements: [
      { name: 'CK', units: 'IU/L', refLow: 25, refHigh: 200 },
    ],
    presets: {
      Normal: {
        CK: 40,
      },
    },
  },
  Troponin: {
    label: 'Troponin T',
    elements: [
      { name: 'TnT', units: 'ng/L', refLow: 0, refHigh: 14 },
    ],
    presets: {
      Normal: {
        TnT: 0,
      },
    },
  },
};